import { useTranslation } from "react-i18next"
import { FloatingLabel } from "./FloatingLabel"
import PropTypes from 'prop-types';

/**
 * A component to use as a placeholder for another component while data is loading/unavailble (most likely due to being offline)
 * @component
 */
const UnavailableComponent = ({ placeholder, text, hideLabel = false }) => {
    const { t } = useTranslation();

    return <FloatingLabel hideLabel={hideLabel} placeholder={placeholder ?? ''} value={true}>
        <div className="w-100 h-100" style={{ border: "3px dashed lightgrey", textAlign: "center"}}>{t(text ?? 'onlineOnlyMessage')}</div>
    </FloatingLabel>
}

UnavailableComponent.propTypes = {
        /**
         * The label for the control
         */
        placeholder: PropTypes.string,

        /**
         * The text to display 
         */
        text: PropTypes.string,
    
        /**
         * Collapses the floating label used for spacing
         */
        hideLabel: PropTypes.bool,
}


export default UnavailableComponent;